import script from "./NotificationComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationComponent.vue?vue&type=script&setup=true&lang=js"

import "./NotificationComponent.vue?vue&type=style&index=0&id=60061c4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60061c4c"]])

export default __exports__